/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

import VerifierApp from '../parts/verify/VerifierApp';

// Return the unauthenticated certificate verifier for /verify-certificate/* paths so it renders WITHOUT
// the app's auth gate (withAuth). Returning undefined for every other path falls through to the base/raas
// app components. This plugin is registered LAST in the app-component extension point, and AppContainer
// evaluates plugins in reverse order, so it is consulted first.
// eslint-disable-next-line consistent-return
function getAppComponent({ location }) {
  const pathname = (location && location.pathname) || (typeof window !== 'undefined' ? window.location.pathname : '');
  if (pathname && pathname.startsWith('/verify-certificate')) {
    return VerifierApp;
  }
}

const plugin = {
  getAppComponent,
};

export default plugin;
